import React, {useState} from 'react';
import assets from "../../../util/assets";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./index.css";
import LabelFormField from "../../LabelFormFields";

NewChatSearch.propTypes = {
    search: PropTypes.func.isRequired,
};

NewChatSearch.defaultProps = {
    searchText:'',
    placeholder:'',
    className:''
};

function NewChatSearch(props) {

    const [chatSearch, setChatSearch] = useState(props.searchText);

    const search = () => {
        if (chatSearch.trim().length >= 1) {
            props.search(chatSearch);
        }
    }
    const clearInput = () => {
        setChatSearch("");
        props.search("");
    }

    const onChange = (e) => {
        setChatSearch(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.target.value.trim().length >= 1) {
                props.search(e.target.value);
            }
        }
    }

    const containerClassname = classnames("display-flex","chat-input-search-container",props.className);
    return (
        <div className={containerClassname} style={props.style}>
            <input
                type="text"
                value={chatSearch}
                className="form-control"
                id="chat-input-text"
                placeholder={props.placeholder.length > 0 ? props.placeholder : "Search or start new chat..."}
                onKeyPress={handleKeyPress}
                onChange={onChange}
            />
            {chatSearch.length > 0 &&
            <img alt="cross" src={assets.broadcast.cross} onClick={clearInput}/>}
            <img alt="search" src={assets.messaging.searchInput} onClick={search}/>
        </div>
    );
}

export default NewChatSearch;